"use strict"; // Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemRandomSource = void 0;

var browser_1 = require("./browser");

var node_1 = require("./node");

var SystemRandomSource = /*#__PURE__*/function () {
  function SystemRandomSource() {
    _classCallCheck(this, SystemRandomSource);

    this.isAvailable = false;
    this.name = ""; // Try browser.

    this._source = new browser_1.BrowserRandomSource();

    if (this._source.isAvailable) {
      this.isAvailable = true;
      this.name = "Browser";
      return;
    } // If no browser source, try Node.


    this._source = new node_1.NodeRandomSource();

    if (this._source.isAvailable) {
      this.isAvailable = true;
      this.name = "Node";
      return;
    } // No sources, we're out of options.

  }

  _createClass(SystemRandomSource, [{
    key: "randomBytes",
    value: function randomBytes(length) {
      if (!this.isAvailable) {
        throw new Error("System random byte generator is not available.");
      }

      return this._source.randomBytes(length);
    }
  }]);

  return SystemRandomSource;
}();

exports.SystemRandomSource = SystemRandomSource;